<template>
  <v-app>
    <v-content>
      <v-container fluid ma-0 pa-0 v-resize="onResize">
        <v-img src="../../static/img/background_small.jpg" :width="x" :height="y" class="bgimage">
          <nav class="navbar navbar-light" style="height: 10px;">
            <a class="navbar-brand" href="#">
              <img src="../assets/img/logo.png" width="60" height="40" class="d-inline-block align-top" alt="">
              <div style="display: inline-block; padding-left: 5px; color: white;font-weight: 700;">
                <span> KENYA COFFEE </span>
              </div>
            </a>
            <div id="navbarNav" style="margin-right: 200px;">
              <ul class="nav justify-content-end">
                <li class="nav-item">
                  <router-link class="nav-link links" to="/">Home</router-link>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://onlinebanking.co-opbank.co.ke/" target="_blank">Co-op Online</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://www.nairobicoffeeexchange.co.ke/" target="_blank">NCE</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://www.agricultureauthority.go.ke/" target="_blank">AFA</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://www.cma.or.ke/" target="_blank">CMA</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links active" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </nav>
          <v-layout align-center row  fill-height wrap>
            <v-flex xs4 offset-xs5 class="loginfront">
              <h3 class="white--text loginhead"> Enter otp sent to your email/phone to proceed </h3>
              <v-flex v-if="response">
                <p class="loginresponse">{{response}}</p>
              </v-flex>
              <v-form>

                <div class="wrap-input100" style="margin-bottom: 40px;">
                <input class="input100" type="text" name="email" v-model="otp.token" v-on:blur="blurOtp" @keyup.enter="validateOTP" :class="removeOtpLabel === true ? 'has-val' : ''">
                <span class="focus-input100"></span>
                <span class="label-input100"> otp</span>
                </div>
              </v-form>
              <div class="logindiv">
                <router-link mt-5 class="pageLink white--text" to="/login"> Back to login?  </router-link>
                <v-btn type="button" class="btn loginbtn primary--text" :loading="loading"  @click="handleValidateOTP"> Submit </v-btn>
           

              </div>
            </v-flex>
          </v-layout>
        </v-img>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import axios from 'axios'
import config from '../config'
import store from '../store'

export default {
  name: 'Login Otp',
  data (router) {
    return {
      section: 'Login Otp',
      loading: false,
      otp: { token: '', userId: 0 },
      response: '',
      message: '',
      snackbar: false,
      snackbarNetwork: false,
      networkMessage: '',
      x: 0,
      y: 0,
      removeUsernameLabel: false,
      removeOtpLabel: false
    }
  },
  mounted () {
    var urlString = window.location.href
    var url = new URL(urlString)
    var message = url.searchParams.get('message')
    this.message = message
    this.onResize()
  },
  watch: {
    networkError: function (val) {
      console.log(val)
      if (val) {
        this.snackbarNetwork = true
        this.networkMessage = 'Connection error: Server Unreachable'
      }
    }
  },
  computed: {
    networkError: function () {
      return store.state.networkError
    }
  },
  methods: {
    onResize () {
      this.x = window.innerWidth
      this.y = window.innerHeight
    },
    handleValidateOTP (event) {
      // Prevent any default behavior
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.validateOTP()
    },

    validateOTP () {
      this.loading = true
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */

      var url = config.serverURI + '/token/validate-otp'
      var token = store.state.tempToken
      this.otp.userId = this.$route.params.id

      axios
        .post(url, this.otp, {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          this.loading = false
          this.$store.commit('TOGGLE_LOADING')

          var data = response.data

          /* Checking if error object was returned from the server */
          if (data.error) {
            var errorName = data.error
            if (errorName) {
              this.response =
                errorName === 'Bad credentials'
                  ? 'Invalid username or password'
                  : errorName
            } else {
              this.response = data.error
            }
            // console.log(this.response)
            this.loading = false
            // this.$router.push(this.otp.userId + '/login/otp-validate')
            return
          }

          console.log(data)
          /* Setting user in the state and caching record to the localStorage */
          if (data.token) {
            var token = 'Bearer ' + data.token

            this.$store.commit('SET_USER', data.user)
            this.$store.commit('SET_TOKEN', token)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(data.user))
              window.localStorage.setItem('token', token)
            }
            this.$router.push(data.redirect ? data.redirect : '/dashboard')
            // this.$router.push(data.redirect ? data.redirect : '/')
          } else {
            this.response = data.error
          }
        })
        .catch(error => {
          this.response = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : String(error)
          this.loading = false
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    checkCreds () {
      this.message = ''
      this.resetResponse()
      var url = config.serverURI + '/token/validate/otp'
      this.loading = true
      axios
        .post(url, { username: this.username.trim(), otp: this.otp })
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            var errorName = data.error
            if (errorName) {
              this.response =
                errorName === 'Bad credentials'
                  ? 'Invalid username or password'
                  : errorName
            } else {
              this.response = data.error
            }
            // console.log(this.response)
            this.loading = false
            return
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data.token) {
            this.username = ''
            this.password = ''
            var token = 'Bearer ' + data.token
            if (config.multifactorAuthOn && !data.user.internalUser) {
              // when multifactor auth is on and user not an internal user
              this.$store.commit('SET_TEMP_TOKEN', token)
              this.$router.push(data.user.id + '/otp-validate')
            } else {
              this.$store.commit('SET_USER', data.user)
              this.$store.commit('SET_TOKEN', token)
              if (window.localStorage) {
                window.localStorage.setItem('user', JSON.stringify(data.user))
                window.localStorage.setItem('token', token)
              }
              this.$router.push(data.redirect ? data.redirect : '/dashboard')
            }
            this.loading = false
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)

          this.response = 'Authentication error'
          this.loading = false
        })
    },
    resetResponse () {
      this.response = ''
    },
    blurEmail () {
      if (this.username === '') {
        this.removeUsernameLabel = false
      } else {
        this.removeUsernameLabel = true
      }
    },
    toggleLoading () {
      this.loading = !this.loading
    },
    blurOtp () {
      if (!this.otp || this.otp.token === '') {
        this.removeOtpLabel = false
      } else {
        this.removeOtpLabel = true
      }
    }
  }
}

</script>
<style scoped>
.labelstyle >>> .v-text-field__slot label {
  color: white;
  font-weight: 300px !important;
  font-family: 'Open Sans', sans-serif;
}

.inputstyle >>> .v-text-field__slot input {
  color: white;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
}

.loginresponse {
  color: red;
  font-weight: 600;
}

.header {
  font-size: 20px;
  font-weight: 700;
  color: white;
  padding-top: 15px
}

.headermotto {
  font-size: 16px;
  font-weight: 500;
  color: white;
}
.logintext {
  font-size: 20px;
  font-weight: 700;
  color: white;
  padding-top: 15px
}
.loginbtn {
  font-weight: bold;
  text-transform: capitalize;
  border-radius: 5px 5px 5px 5px;
  float: right;
  background-color: #B2CCC4 !important;
  width: 100px;
  border-color: #FFF;
}

.footer {
  background: #000000B2 0% 0% no-repeat padding-box;
  opacity: 0.7;
  height: 50px;
}

.loginfront {
  background: #000000B2 0% 0% no-repeat padding-box;
  padding-left: 40px;
}
.logindiv {
  margin: 0;
  width: 80%;
  margin-bottom: 20px;
  height: 50px;
  text-align: justify;
}
.pageLink {
  font-size: 14px;
  padding-top:10px;
  font-style: "Brandon Grotesque";
}
.loginhead {
  font-size: 14px;
  font-weight: 700;
  font-style: "Brandon Grotesque";
  margin-top:30px;
  margin-bottom:20px;
}
.links {
  padding-left: 30px;
  padding-right: 30px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  font-style:"Brandon Grotesque";
}
.active {
  width: 150px;
  background-color: #7BC243;
  text-align: center;
  border-radius: 5px 5px 5px 5px;
}
</style>
